"use client";

import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { useContext, useState } from "react";
import { UIContext } from "../../contexts/UIContext";

export default function Tabs({ tabs = [], onTabDeleted }) {
  const { editUI } = useContext(UIContext);
  const [selected, setSelected] = useState(tabs?.find((t) => t?.default)?.name);
  return (
    <div className="relative">
      <div className="bg-[#202731] rounded-md p-1 flex w-full m-1 overflow-x-auto">
        <nav aria-label="Tabs" className="flex space-x-4 ">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className="group space-x-4 flex items-center  text-gray-500 data-[selected='true']:text-white hover:text-gray-700 rounded-md px-3 py-2 font-medium cursor-pointer whitespace-nowrap"
              data-selected={selected === tab?.name ? "true" : null}
              onClick={() => {
                setSelected(tab?.name);
                tab.onTabSelected();
              }}
            >
              <a
                href={tab.href}
                aria-current={tab.current ? "page" : undefined}
              >
                {tab.name}
              </a>
              {tab.children}
            </div>
          ))}
        </nav>
      </div>
      {editUI && (
        <>
          <div
            class="cursor-pointer absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900"
            onClick={onTabDeleted}
          >
            X
          </div>
          <div class="cursor-pointer absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-blue-500 border-2 border-white rounded-full -top-2 -start-2 dark:border-gray-900">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
              />
            </svg>
          </div>
        </>
      )}
    </div>
  );
}
